import React from 'react'
import './App.css'
import Users from './features/users/Users'

function App() {
	return (
		<div className='App'>
			<header className='App-header'>
				<h2>Nivimu front Test</h2>
			</header>
			<main>
				<Users/>
			</main>
		</div>
	)
}

export default App
